import {LeadCaptureTable} from './views/LeadCaptureTable';
import { WebsiteTable } from './views/WebsiteTable';

export const ScreenMapping = [
  {
    id: 'unthinkableContacts',
    view: <LeadCaptureTable />,
  },
  {
    id: 'unthinkableWebsites',
    view: <WebsiteTable />,
  },
  {
    id: 'townkartLeads',
    view: <LeadCaptureTable />,
  }
];